/* tslint:disable */
/* eslint-disable */
/**
 * openapi.yml
 * オンラインCE API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AvailableCoefficientSet } from './AvailableCoefficientSet';
import {
    AvailableCoefficientSetFromJSON,
    AvailableCoefficientSetFromJSONTyped,
    AvailableCoefficientSetToJSON,
} from './AvailableCoefficientSet';

/**
 * 利用可能係数セット取得レスポンス
 * @export
 * @interface AvailableCoefficientSetList
 */
export interface AvailableCoefficientSetList {
    /**
     * ステータス
     * @type {string}
     * @memberof AvailableCoefficientSetList
     */
    status?: string;
    /**
     * メッセージ
     * @type {string}
     * @memberof AvailableCoefficientSetList
     */
    message?: string;
    /**
     * 利用可能係数セット一覧
     * @type {Array<AvailableCoefficientSet>}
     * @memberof AvailableCoefficientSetList
     */
    availableCoefficientSetList?: Array<AvailableCoefficientSet>;
}

/**
 * Check if a given object implements the AvailableCoefficientSetList interface.
 */
export function instanceOfAvailableCoefficientSetList(value: object): value is AvailableCoefficientSetList {
    return true;
}

export function AvailableCoefficientSetListFromJSON(json: any): AvailableCoefficientSetList {
    return AvailableCoefficientSetListFromJSONTyped(json, false);
}

export function AvailableCoefficientSetListFromJSONTyped(json: any, ignoreDiscriminator: boolean): AvailableCoefficientSetList {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'] == null ? undefined : json['status'],
        'message': json['message'] == null ? undefined : json['message'],
        'availableCoefficientSetList': json['availableCoefficientSetList'] == null ? undefined : ((json['availableCoefficientSetList'] as Array<any>).map(AvailableCoefficientSetFromJSON)),
    };
}

export function AvailableCoefficientSetListToJSON(value?: AvailableCoefficientSetList | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'status': value['status'],
        'message': value['message'],
        'availableCoefficientSetList': value['availableCoefficientSetList'] == null ? undefined : ((value['availableCoefficientSetList'] as Array<any>).map(AvailableCoefficientSetToJSON)),
    };
}

